<div class="container">
  <div class="center py-2">
    <h3 *ngIf="title">{{ title }}</h3>
    <p>{{ i18n?.TEXT }}</p>

    <nb-icon icon="loader-outline" status="primary" class="rotating"></nb-icon>
  </div>
</div>
